import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as api from '../../../shared/api/apihandler';

export class CasePartnerFunctions {
    constructor(private http:HttpClient){}
    
    getCaseFromPartner(caseId:string){
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return this.http.get(api.jubloApi + 'api/Partner/ReceivedPartnerCaseInfo/' + caseId, { headers })
    }
    
    getCaseDistributedPartners(caseId:string) {
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        return this.http.get(api.jubloApi + 'api/Partner/PartnerCaseInfo/' + caseId, { headers })
    }
}